import { render, staticRenderFns } from "./CangKuKanban.vue?vue&type=template&id=37c95618&"
import script from "./CangKuKanban.vue?vue&type=script&lang=js&"
export * from "./CangKuKanban.vue?vue&type=script&lang=js&"
import style0 from "./CangKuKanban.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports